import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';

const MdmSelect = () => import('~/components/atoms/MdmSelect.vue');

const SquareImage = () => import(
/* webpackChunkName: "square-image" */
'~/components/atoms/Product/SquareImage.vue');

export default {
  name: 'TheVariantsSection',
  components: {
    MdmSelect,
    SquareImage
  },
  props: {
    variants: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      truncated: true
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    sharedEnv: 'sharedEnv/getSharedEnv'
  }), {
    maxCount() {
      return this.isDesktop() ? 5 : 8;
    }

  }),
  methods: _objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  }), mapActions({
    fetchProduct: 'product/fetchProduct'
  }), {
    truncatedCount(count) {
      if (this.isMobile()) {
        return 0;
      }

      return count - this.maxCount;
    },

    truncatedCountMessage(count) {
      return this.$t(this.truncated ? 'show' : 'hide', {
        count: this.truncatedCount(count)
      });
    },

    fetch(reference, options) {
      var _this = this;

      return _asyncToGenerator(function* () {
        const args = {
          alias: reference,
          profileId: _this.$cookies.get('eb-profile') ? _this.$cookies.get('eb-profile').split(':')[0] : ''
        };
        yield _this.fetchProduct(args);

        if (window.history.replaceState) {
          const {
            slug
          } = options.find(option => option.reference === reference);
          const {
            search,
            hash
          } = window.location;
          const path = "".concat(slug, "-").concat(reference, ".htm").concat(search).concat(hash);
          window.history.replaceState('', '', path);
        }

        _this.$root.$emit('change-variant');
      })();
    },

    tracking(eventAction) {
      return {
        fn: 'track-event',
        data: {
          event_action: eventAction,
          event_category: 'FicheProduit',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    }

  })
};